/** Muss mit den Defaults in `server/services/documents.ts` übereinstimmen. */
import { isDunningDocumentTextType } from '../../invoices/utils/dunningDocument';
import { DUNNING_DEFAULT_EMAIL_BODIES } from '../../invoices/utils/dunningTemplates';

export const DEFAULT_SEND_PDF_EMAIL_BODY_TEMPLATE = [
  "{{GREETING}}",
  "",
  "anbei schicke ich Ihnen unser {{DOCUMENT_TYPE}} zu.",
  "",
  "Schauen Sie doch mal drüber – falls Sie Änderungen wünschen oder Fragen haben, melden Sie sich einfach bei mir.",
].join("\n");

export const DEFAULT_INVOICE_SEND_PDF_EMAIL_BODY_TEMPLATE = [
  "Sehr geehrte Damen und Herren,",
  "",
  "anbei übersenden wir Ihnen unsere Rechnung {{INVOICE_NUMBER}} vom {{DATE}} in Höhe von {{AMOUNT}}.",
  "",
  "Wir bitten um Begleichung des Betrages bis zum {{DUE_DATE}} auf das unten angegebene Konto.",
  "",
  "Für Rückfragen stehen wir Ihnen jederzeit gerne zur Verfügung.",
].join("\n");

/** Muss mit `DEFAULT_GUTSCHRIFT_SEND_PDF_EMAIL_BODY_TEMPLATE` in `server/services/documents.ts` übereinstimmen. */
export const DEFAULT_GUTSCHRIFT_SEND_PDF_EMAIL_BODY_TEMPLATE = [
  "Sehr geehrte Damen und Herren,",
  "",
  "anbei übersenden wir Ihnen die Gutschrift {{INVOICE_NUMBER}} vom {{DATE}} in Höhe von {{AMOUNT}}.",
  "",
  "Für Rückfragen stehen wir Ihnen jederzeit gerne zur Verfügung.",
].join("\n");

export function getDefaultSendPdfEmailBodyTemplate(documentTypeLabel: string): string {
  const t = documentTypeLabel.trim();
  if (isDunningDocumentTextType(t)) return DUNNING_DEFAULT_EMAIL_BODIES[t];
  if (t === "Rechnung") return DEFAULT_INVOICE_SEND_PDF_EMAIL_BODY_TEMPLATE;
  if (t === "Gutschrift") return DEFAULT_GUTSCHRIFT_SEND_PDF_EMAIL_BODY_TEMPLATE;
  return DEFAULT_SEND_PDF_EMAIL_BODY_TEMPLATE;
}

export type SendPdfEmailTemplateValues = {
  invoiceNumber?: string;
  date?: string;
  amount?: string;
  dueDate?: string;
};

export function applySendPdfEmailBodyTemplate(
  template: string | null | undefined,
  greeting: string,
  documentTypeLabel: string,
  values: SendPdfEmailTemplateValues = {},
): string {
  const t = (template?.trim() || getDefaultSendPdfEmailBodyTemplate(documentTypeLabel)).trim();
  return t
    .replace(/\{\{GREETING\}\}/g, greeting)
    .replace(/\{\{DOCUMENT_TYPE\}\}/g, documentTypeLabel)
    .replace(/\{\{INVOICE_NUMBER\}\}/g, values.invoiceNumber ?? "")
    .replace(/\{\{DATE\}\}/g, values.date ?? "")
    .replace(/\{\{AMOUNT\}\}/g, values.amount ?? "")
    .replace(/\{\{DUE_DATE\}\}/g, values.dueDate ?? "");
}
